export default {
  PASS_RESET: 'pass_reset',
  PROJECT_DELETED: 'project_deleted',
  PROJECT_ARCHIVED: 'project_archived',
  PROJECT_RESTORED: 'project_restored',
  EMAILS_SEND: 'emails_send',
  ACTIVATION_LINK_SEND: 'activate_send',
  RESET_TOKEN_INVALID: 'token_invalid',
};
